import EnvironmentConfig from '../interfaces/EnvironmentConfig'

const developmentConfig: EnvironmentConfig = {
    dashboardUrl: 'http://localhost:5335',
    onboardingDashboardUrl: 'https://onboarding.qa.casaretail.ai',
    ruleServerUrl: 'http://localhost:3004',
    apiServerUrl: 'http://localhost:3007',
    redmineUrl: 'https://redmine.casaretail.ai',
    casaWebAppUrl: 'http://localhost:3020',
    casaEcomUrl: 'https://ecom.casaqa.ajira.tech',
    casaBeatUrl: 'https://beat-api.casaqa.ajira.tech',
    turnedOffFeatures: [],
    keycloakConfig: {
        url: `https://auth.qa.casaretail.ai`,
        realm: `casa`,
        clientId: `casa_dashboard`,
    },
    ruleUiUrl: 'https://rules.casaqa.ajira.tech',
    financeOnboarding: {
        // Local dev points at the QA n8n; its webhook allows http://localhost:3011.
        webhookUrl: 'https://n8n.casaqa.ajira.tech/webhook/finance-onboarding',
        submitToken: 'fb4yOjDdof5q5v9N4i8zKERMKtDKf0Jo',
        // 'localhost' is a registered domain on this reCAPTCHA site.
        recaptchaSiteKey: '6Lc17oEtAAAAAMnqd0yW_XEbjn0K1m5eF13sOF9z',
    },
}

export default developmentConfig
